import fetch from '@portal/fetch';
import { parse, stringify } from 'qs';

// 将多个url参数组成字符串
function formatObjToParamStr(paramObj) {
  if (!paramObj) {
    return '';
  }

  return Object.keys(paramObj)
    .map(key => {
      const value = paramObj[key];
      return value == null ? null : `${key}=${value}`;
    })
    .filter(item => item !== null)
    .join('&');
}

function getRequestUrl(url, params) {
  let requestUrl = url;
  const paramStr = formatObjToParamStr(params);

  if (paramStr) {
    const separator = requestUrl.indexOf('?') === -1 ? '?' : '&';
    requestUrl += `${separator}${paramStr}`;
  }

  return requestUrl;
}

function getQueryByName(name) {
  const queryString = window.location.search.split('?')[1] || '';
  const query = parse(queryString);
  return query[name] || '';
}

function post(url, queries, config) {
  const shopId = getQueryByName('shopId');
  if (shopId === '') {
    throw new Error('shop id is a will pass parameters');
  }
  const newUrl = /shopId=/.test(url) ? url : `${url}?${stringify({ shopId })}`; // url中含有shopId则不需要加上shopId了
  return fetch.post(newUrl, queries, config);
}

function get(url = '', queries, config) {
  const newQueries = queries || {};
  const shopId = getQueryByName('shopId') || '';
  const hasUrlShopId = /shopId=/.test(url);
  if (!newQueries.hasOwnProperty('shopId') && !hasUrlShopId) {
    newQueries.shopId = shopId;
  }
  const urlAry = url.split('?');
  const queryString = urlAry[1] || '';
  const query = parse(queryString);
  const param = Object.assign({}, query, newQueries);
  if (!param.shopId) {
    throw new Error('shop id is a will pass parameters');
  }
  return fetch.get(urlAry[0], param, config);
}

function goto(url, params) {
  const requestUrl = getRequestUrl(url, params);

  location.href = requestUrl;
}

export default {
  get,
  post,
  goto,
};



// WEBPACK FOOTER //
// ./src/helper/fetch-helper.js